module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/background_desktop-cf74fc7956776cac03357c7f5cba6ce4.webp";